import styled from 'styled-components';
import { Button } from 'antd';

export const ButtonWrapper = styled(Button)`
  font-size: 20px !important;
  margin-left: 10px;
  padding: 2px 15px;
`;
